import router from "./router";
import store from "./store";
import { getRegisterProcessPA } from "@/api/finance";
import { getyellowPageInfo } from "@/api/personcenter";

// 拿用户信息判断certifyStatus，有没有买卖家资质，
//如果没有，next()
function verifyStatus() {
  const { companyStatus } = store.getters['user/userInfo'];
  if (companyStatus != 5) {
    return `/certification/company`;
  } else {
    return;
  }
}

function getTitle(to) {
  let name = store.getters['user/userInfo'].company?.name;
  if (name) {
    document.title = to.meta.title ? to.meta.title + "-" + name : "易缆网";
  } else {
    document.title = "易缆网";
  }
}
router.beforeEach(async (to, from, next) => {
  const hasToken = store.state.user.token;
  if (hasToken) {
    if (to.path === "/login") {
      next({ path: "/" });
    } else {
      const userInfo = store.getters['user/userInfo'];
      if (userInfo && userInfo.mobile) {
        if (to.fullPath.includes("/buyerCenter") || to.meta.needbuyer) {
          next(verifyStatus());
        } else if (to.fullPath.includes("/sellerCenter")) {
          const path = verifyStatus();
          if (path) {
            next(path);
          } else {
            const data = await getyellowPageInfo();
            if (data.data.data.id) {
              next();
            } else {
              next("/center/yellow-pages");
            }
          }
        } else if (to.fullPath.includes("/finance")) {
          let process = await getRegisterProcessPA();
          if (process.data.code == 0) {
            switch (process.data.data) {
              case -1:
                next();
                break;
              case 0:
                if (to.path == "/finance/account/further-information") {
                  next();
                } else {
                  next({ path: "/finance/account/further-information" });
                }
                break;
              case 1:
                if (to.path == "/finance/account/password") {
                  next();
                } else {
                  next({ path: "/finance/account/password" });
                }
                break;
              case 1.1:
                if (to.path == "/finance/cardBinding/add") {
                  next();
                } else {
                  next({ path: "/finance/cardBinding/add" });
                }
                break;
              case 2:
                if (to.path == "/finance/cardBinding/check-money") {
                  next();
                } else {
                  next({ path: "/finance/cardBinding/check-money" });
                }

                break;
              case 3:
                next();
                break;
              default:
                next();
            }
            next();
          } else {
            next({ path: "/" });
          }
        } else {
          next();
        }
      } else {
        try {
          await store.dispatch("user/getInfo");
          next({ ...to, replace: true });
        } catch (error) {
          await store.dispatch("user/removeToken");
          next();
        }
      }
    }
  } else {
    if (
      (to.meta && to.meta.isLogin === false) ||
      (to.matched[0].meta && to.matched[0].meta.isLogin === false)
    ) {
      // in the free login whitelist, go directly

      next();
    } else {
      // next()
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.fullPath}`);
    }
  }
});

router.afterEach((to) => {
  // 设置页面标题
  getTitle(to);
  // document.title = to.meta.title
  // // 设置页面滚动条位置
  // window.scrollTo(0, 0)
});

//该方法用于判断是否进入手机端
function isMobile() {
  var userAgent = navigator.userAgent || window.opera;
  // 常见的手机浏览器User Agent关键词
  var mobileKeywords = [
    "android",
    "iphone",
    "ipad",
    "ipod",
    "blackberry",
    "mini",
    "windows ce",
    "palm",
    "webos",
    "incognito",
    "opera mobi",
    "hpwos",
    "mot",
    "nokia",
    "fennec",
    "htc_",
  ];
  // 检查是否包含任意一个关键词
  return mobileKeywords.some(
    (keyword) => userAgent.toLowerCase().indexOf(keyword) > -1
  );
}
